export const DOMAIN_BELLA_SICILIA = "bellasicilia.be";

export const STORE_ID_BELLA_SICILIA = 4;
export const STORE_ID_ROESELARE = 2;
export const STORE_ID_DEERLIJK = 1;
export const STORE_ID_TIENEN = 3;
